import Tag from '@sharedComponents/Tag';
import { useTranslation } from 'react-i18next';

const COLORS = { DRAFT: 'neutral', PREPRODUCTION: 'teal', PRODUCTION: 'success' };

/** Badge of the publication status of a collection: 'DRAFT', 'PREPRODUCTION' or 'PRODUCTION'. Nothing shows without a status. */
const CollectionStatusBadge = ({ status = null }) => {
    const { t } = useTranslation('bo');
    const labels = { DRAFT: t('Draft'), PREPRODUCTION: t('Preproduction'), PRODUCTION: t('Production') };

    if (!COLORS[status]) return null;

    return (
        <Tag color={COLORS[status]} size="xs" fontSize="xs">
            {labels[status]}
        </Tag>
    );
};

export default CollectionStatusBadge;
